// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input__nJY8g","search-icon":"SearchInput_search-icon__FrISA"};